import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from '../components/Home';
import About from '../components/About';
import Contact from '../components/Contact';
import RARPage from '../components/RAR';
// import Scrims from '../components/Scrims';
import StatsNav from '../components/Stats';
import Stats from '../components/StatsTable';
import PlayerRankings from '../components/PlayerRankings';
import Players from '../components/Players';
import PlayerProfile from '../components/Players/Profile';
import FourOhFour from '../components/FourOhFour';

const RoutesList = () => {
  return (
    <>
    <Routes>
      <Route path='/player/:playerId/:tab?' element={<PlayerProfile />} />
      <Route path='/players/' element={<Players />} />
      <Route exact path='/player-rankings/' element={<PlayerRankings />} />
      <Route exact path='stats/:statsType/byTournament/:tournamentId' element={<Stats />} />
      <Route path='/stats' element={<StatsNav />} />
      {/* <Route exact path='/scrims' element={<Scrims />} /> */}
      <Route exact path='/rar' element={<RARPage />} />
      <Route exact path='/about' element={<About />} />
      <Route exact path='/contact' element={<Contact />} />
      <Route exact path='/' element={<Home />} />
      <Route path='/404' element={<FourOhFour />} />
      <Route element={<FourOhFour />} />
    </Routes>
    </>
  )
}

export default RoutesList;